import styled from 'styled-components';

export const Label = styled.h5`
  margin: 0;
  margin-top: ${props => props.theme.metrics.smallMargin}px;
  margin-right: ${props => props.theme.metrics.smallMargin}px;
  width: 100%;
  padding-bottom: ${props => (!props.withPadding ? '0' : props.theme.metrics.margin)}px;
`;

export const OptionalLabel = styled.p`
  margin: 0;
  margin-top: ${props => props.theme.metrics.smallMargin}px;
  margin-right: ${props => props.theme.metrics.smallMargin}px;
  color: ${props => props.theme.colors.primaryText}px;
`;

export const RowWrapper = styled.div`
  margin-top: ${props => props.theme.metrics.smallMargin}px;
  display: ${props => (props.hidden ? 'none' : 'flex')};
`;

export const PlayerDemo = styled.div`
  width: 90%;
  height: 100%;
  margin: auto;
`;

export const FlexPlayerDemo = styled(PlayerDemo)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MargedBlock = styled.div`
  margin-top: ${props => props.theme.metrics.margin}px;
`;

export const ColorPickerContainer = styled.div`
  display: inline-block;
`;



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/styles.js